import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CourseTree } from "@/components/course/tree/CourseTree";
import { CourseContent } from "@/components/course/CourseContent";

export const MobileCourseLayout = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="relative flex h-full min-h-0 w-full flex-col md:hidden">
      {/* Mobile Menu Button */}
      {!isMobileMenuOpen && (
        <Button
          variant="ghost"
          size="icon"
          className="fixed top-20 left-4 z-50"
          onClick={() => setIsMobileMenuOpen(true)}
        >
          <Menu className="h-6 w-6" />
        </Button>
      )}

      {/* Mobile Overlay Sidebar */}
      {isMobileMenuOpen && (
        <>
          {/* Backdrop */}
          <button
            type="button"
            className="fixed inset-0 z-40 cursor-default bg-black/50"
            aria-label="Menü schließen"
            onClick={() => setIsMobileMenuOpen(false)}
          />
          {/* Sidebar */}
          <div className="fixed left-0 top-0 h-full w-80 bg-sidebar border-r z-40 overflow-y-auto">
            <Button
              variant="ghost"
              size="icon"
              className="absolute top-4 right-4 z-10"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <X className="h-5 w-5" />
            </Button>
            <CourseTree />
          </div>
        </>
      )}

      {/* Mobile Content */}
      <div className="flex h-full min-h-0 w-full flex-col pt-16">
        <CourseContent />
      </div>
    </div>
  );
};
